"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var ModalAlert_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalAlert"));
var single_1 = require("utils/selectors/single");
var AuthenticatorModal = function () {
    var userHasMfa = (0, react_redux_1.useSelector)(single_1.selectUserHas2fa);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    if (!(company === null || company === void 0 ? void 0 : company.requiresMfa) || userHasMfa) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ModalAlert_1.default, { open: true, status: "success", title: "Multi-factor authentication required", url: "/settings/my-account", icon: "/ShieldCheck.svg", description: "Multi-factor authentication is required to use the platform.", buttonText: "Go to My Accounts" }));
};
exports.default = AuthenticatorModal;
